import React from 'react'

const Nav = ({ children }) => {
  return <nav>{children}</nav>
}
export default Nav
